module.exports = __webpack_public_path__ + "media/images/zalo_icon-a34fd3bcaa7f5992a73b56663735ed1b.png";